import { ReactNode } from 'react'

const EventComponentWrapper = ({ children, ...props }: { children: ReactNode }) => (
  <div
    style={{
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }}
    {...props}
  >
    {children}
  </div>
)

export default EventComponentWrapper
